import React, { LabelHTMLAttributes } from 'react'
import * as Styled from './Field.styles'

interface CustomProps {
  /**
   * Size of the field
   */
  size?: 'small' | 'medium' | 'large'
  /**
   * Label contents
   */
  label?: React.ReactNode
  /**
   * Has disabled state?
   */
  disabled?: boolean
  /**
   * Bottom error string contents
   */
  error?: React.ReactNode
  /**
   * Bottom caption (hint) string contents
   */
  caption?: React.ReactNode
  /**
   * Keep space for error/caption? (prevents jumps in forms with errors)
   */
  fixedCaption?: boolean
}

export type ComponentProps = CustomProps & LabelHTMLAttributes<HTMLLabelElement>

const Field: React.FC<ComponentProps> = ({ size = 'large', label, disabled: isDisabled, error, caption, fixedCaption, children, ...labelProps }) => (
  <Styled.Label fixedCaption={fixedCaption} isDisabled={isDisabled} {...labelProps}>
    <Styled.LabelText size={size}>{label}</Styled.LabelText>
    {children}
    {error ? <Styled.Error>{error}</Styled.Error> : !!caption && <Styled.Caption>{caption}</Styled.Caption>}
  </Styled.Label>
)

export default Field
